import { z } from 'zod';
import { DataGeneratorInput } from 'libs/end-to-end/src/data-generator/data-generator-input';

export const DataGeneratorRunStatus = z
  .enum(['running', 'fail', 'success'])
  .describe('DataGeneratorRunStatus');

export type DataGeneratorRunStatus = z.infer<typeof DataGeneratorRunStatus>;

export const DataGeneratorRun = z.object({
  runId: z.string(),
  createdAtEpoch: z.number(),
  status: DataGeneratorRunStatus,
  outputConsoleUrl: z.string().nullable(),
  config: DataGeneratorInput,
});

export type DataGeneratorRun = z.infer<typeof DataGeneratorRun>;

export const DataGeneratorRuns = z.object({
  runs: z.array(DataGeneratorRun),
});

export type DataGeneratorRuns = z.infer<typeof DataGeneratorRuns>;
